export default class RoleMatcher {
  /* eslint-disable */
  constructor(currentUserRoles) {
    this.currentUserRoles = currentUserRoles;
  }

  has(arg) {
    
    if (
      !this.currentUserRoles ||
      !this.currentUserRoles.length
    ) {
      return false;
    }

    if (!arg) {
      return true;
    }

    const rolesToCompare = Array.isArray(arg) ? arg : [arg];

    return this.currentUserRoles.some((role) =>
      rolesToCompare.some(
        (allowedRole) => allowedRole === role
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/role-matcher.js